/**
 * This file was automatically generated by `IconCodeGenerator`.
 * DO NOT MODIFY IT BY HAND. Instead, follow the instructions at `src/shared/joykit/packages/core/icons/README.md`.
 */

import * as React from 'react';

import createSvgIcon from '../createSvgIcon';

import { SvgIconConfig } from '../types';

const config: SvgIconConfig = {
  title: 'Refund',
  definitions: {
    '24': {
      viewBox: '0 0 24 24',
      path: (
        <>
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M7.00129 20.6147C6.71431 20.449 6.61599 20.0821 6.78167 19.7951C6.94736 19.5081 7.31431 19.4098 7.60129 19.5755C11.7846 21.9907 17.1339 20.5574 19.5491 16.374C21.9644 12.1907 20.5311 6.84146 16.3477 4.4262C12.1644 2.01093 6.81514 3.44426 4.39987 7.62761C4.3947 7.63657 4.38933 7.64534 4.38378 7.65393L5.09493 7.52091C5.42065 7.45998 5.73409 7.67464 5.79502 8.00036C5.85594 8.32609 5.64128 8.63953 5.31556 8.70045L3.18623 9.09874C2.86051 9.15967 2.54707 8.94501 2.48614 8.61929L2.08785 6.48996C2.02692 6.16424 2.24158 5.8508 2.56731 5.78987C2.89303 5.72894 3.20647 5.9436 3.26739 6.26933L3.39742 6.96445C6.16126 2.25592 12.2115 0.652525 16.9477 3.38697C21.705 6.1336 23.335 12.2167 20.5884 16.974C17.8417 21.7314 11.7586 23.3613 7.00129 20.6147Z"
            fill="currentColor"
          />{' '}
          <path
            d="M12.5026 5.27029C12.5026 4.93892 12.234 4.67029 11.9026 4.67029C11.5713 4.67029 11.3026 4.93892 11.3026 5.27029V6.43535C10.1123 6.63039 9.17769 7.50318 8.89113 8.48272C8.65783 9.28022 8.71877 10.0834 9.24086 10.7766C9.73822 11.4371 10.5898 11.9091 11.7386 12.2356C12.7836 12.5326 13.3872 12.8999 13.7062 13.2997C14.0023 13.6707 14.1173 14.1518 13.9844 14.8616C13.9211 15.1999 13.6813 15.5769 13.2859 15.8822C12.8952 16.1837 12.3964 16.3796 11.8863 16.3936C11.2876 16.4099 10.6341 16.1779 10.0698 15.4813C9.86117 15.2238 9.48335 15.1841 9.22586 15.3927C8.96838 15.6013 8.92875 15.9791 9.13734 16.2366C9.76683 17.0137 10.5287 17.4264 11.3026 17.5522V18.7298C11.3026 19.0611 11.5713 19.3298 11.9026 19.3298C12.234 19.3298 12.5026 19.0611 12.5026 18.7298V17.5265C13.0686 17.4127 13.5909 17.1627 14.0192 16.832C14.5867 16.3939 15.0337 15.7781 15.1639 15.0825C15.342 14.1312 15.2148 13.2663 14.6442 12.5512C14.0965 11.8648 13.2087 11.4059 12.0666 11.0813C11.0283 10.7862 10.4694 10.4133 10.1994 10.0547C9.95416 9.72903 9.89084 9.33928 10.0429 8.81965C10.2254 8.19556 10.9571 7.55958 11.8787 7.59636C12.3192 7.61394 12.836 7.78639 13.3828 8.24204C13.6374 8.45417 14.0158 8.41977 14.2279 8.16519C14.44 7.91062 14.4056 7.53228 14.151 7.32015C13.6131 6.87187 13.0542 6.59751 12.5026 6.47343V5.27029Z"
            fill="currentColor"
          />
        </>
      ),
    },
  },
};

const icon = createSvgIcon(config);
export default icon;
